import React from "react";
import { startCase } from "lodash";
import { Box, Tab, Tabs } from "@mui/material";

import Panel from "../../../../components/Panel";
import { CalendarSettings } from "./CalendarSettings";
import SettingsButton from "../../../../components/SettingsButton/SettingsButton";
import { GlobalSettings } from "../GlobalSettings/GlobalSettings";

interface Props {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  renderSettingButton?: boolean;
  onViewChange: () => void;
}

const TABS = {
  CALENDAR_SETTINGS: "calendarSettings",
  COMMON_SETTINGS: "globalSettings"
};

// eslint-disable-next-line import/prefer-default-export
export const CalendarSettingsPanel = ({
  open,
  onOpenChange,
  renderSettingButton = true,
  onViewChange
}: Props): React.ReactNode => {
  const [internalOpen, setInternalOpen] = React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState(TABS.CALENDAR_SETTINGS);

  const isControlled = typeof open === "boolean";
  const actualOpen = isControlled ? open : internalOpen;

  const setOpen = (value: boolean): void => {
    if (isControlled) {
      onOpenChange?.(value);
    } else {
      setInternalOpen(value);
    }
  };

  return (
    <>
      {renderSettingButton && <SettingsButton onClick={() => setOpen(!actualOpen)} />}

      {actualOpen && (
        <Panel
          onClose={() => setOpen(false)}
          title="Calendar Settings"
          contentStyle={{ py: 0, height: "calc(100vh - 50px)" }}
        >
          <Box sx={{ borderLeft: 1, borderRight: 1, borderColor: "divider" }}>
            <Tabs
              value={selectedTab}
              onChange={(_, newValue) => setSelectedTab(newValue)}
              sx={{
                height: "50px",
                borderBottom: 1,
                borderColor: "divider"
              }}
            >
              <Tab label={startCase(TABS.CALENDAR_SETTINGS)} value={TABS.CALENDAR_SETTINGS} />
              <Tab label={startCase(TABS.COMMON_SETTINGS)} value={TABS.COMMON_SETTINGS} />
            </Tabs>

            <Box sx={{ height: "calc(100vh - 100px)", p: 2, overflowY: "auto" }}>
              {selectedTab === TABS.CALENDAR_SETTINGS && (
                <CalendarSettings onViewChange={onViewChange} />
              )}

              {selectedTab === TABS.COMMON_SETTINGS && <GlobalSettings />}
            </Box>
          </Box>
        </Panel>
      )}
    </>
  );
};
